import { AppError, AppResponse } from "../entity/BaseApi";

export const isAppResponse = (response: any): response is AppResponse => {
  return "status" in response && "body" in response;
};

export const isAppError = (error: any): error is AppError => {
  return "errorCode" in error;
};

export const toMessageError = (e: any): string => {
  let message = isAppError(e) ? e.errorCode : "UNEXPECTED_ERROR";
  message = message ?? "UNEXPECTED_ERROR";
  return message;
};
